import { gql } from '@apollo/client';

export const PEOPLE = gql`
    query universalPersonSearch($filter: SystemContactFilter) {
        system {
            contacts(filter: $filter) {
                id
                firstName
                lastName
                emailAddress
                user {
                    id
                    username
                    credentials {
                        id
                        apiKey
                    }
                }
            }
        }
    }
`;
